import { z } from 'zod';
import { WithId } from './WithId';

export const JawScanCreateSchema = z.object({
  teethEdges: z.array(z.number().int()),
});

export type JawScanCreate = z.infer<typeof JawScanCreateSchema>;

export type JawScanResponse = WithId & {
  model3dUrl: string;
  teethEdges: number[];
};

export type JawScanSummaryResponse = WithId & {
  model3dUrl: string;
};
